// extracted by mini-css-extract-plugin
module.exports = {"loading":"styles-module--loading--3aXjs"};